//------------------
// CONFIG FILE FOR M.E MUSIC PLAYER
//------------------


// AE --------------
export const ae_redirect_url                   =  window.location.href + '/#/';
export const ae_form_ID                        = '50053';
export const ae_api_key                        = 'bf72cb1e7a24bbd7d12b10d8e7e304c5';
export const ae_api_key_enc                    = '5b67bb2f1fc43016bbf7bd855b3efcf2a8a1ffe6c68021f6134895b0fabf77f7';
export const ae_spotify_auth_url               = 'https://sme.theappreciationengine.com/brand/sony-music-us-columbia/register/2682?return=' + ae_redirect_url;
export const ae_brand_ID                       = '3444493';
export const ae_segment_ID                     = '838891';
export const ae_default_mailinglist_ID         = 'a0S61000001YpyPEAS';

// NON AE ----------
//export const spotify_client_key    = '9e6c8e78e7d94b2ebf6538ff9789e6af';
export const spotify_redirect_url  = window.location.href + '/#/';

// Apple
//export const apple_developer_token = "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ilc2QzI2OEwyUTYifQ.eyJpYXQiOjE1NjkyMzM5MTgsImV4cCI6MTU4NDc4NTkxOCwiaXNzIjoiRVdaREg0QzU1TSJ9.D0pfie4vJWlB8L5SdaeeqwmmrLI7U8Mvy1nOz7_w8VRWnqzgc3HUvY8M7NmUW6g7Q9rrMzRKjtu_fXO800ElmQ";
